const Earth = ({ width }) => {
    return (
        <div className={`earth-icon ${width}`}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                enableBackground="new 0 0 100 100"
                version="1.1"
                viewBox="0 0 100 100"
                xmlSpace="preserve"
            >
                <path
                    fill="currentColor"
                    d="M93.8 39.9h-22c-6.6 0-12-5.4-12-12 0-2.4.7-4.7 2-6.7l8.5-12.7 5.4 3.6-8.5 12.7c-.6.9-.9 2-.9 3.1 0 3.1 2.5 5.6 5.6 5.6h22v6.4zM76.1 88l-4.7-10.1c-.9-1.9-2.9-3.2-5-3.2-6.6 0-12-5.4-12-12 0-4.4 2.4-8.4 6.2-10.5l3.2-1.8c1.8-1 3.8-1.5 5.9-1.5h26.8v6.5H69.6c-.9 0-1.9.2-2.7.7l-3.2 1.8c-1.8 1-2.8 2.8-2.8 4.8 0 3.1 2.5 5.5 5.5 5.5 4.6 0 8.9 2.7 10.9 6.9L82 85.2 76.1 88zM19.5 63.2c-1.3 0-2.6-.6-3.5-1.6L1 44.8l4.9-4.3 11.9 13.4v-5.8c0-3.5 2.8-6.3 6.3-6.3h3.5c1.5 0 2.9-.5 4-1.5l6.6-6.1c1.2-1.1 1.9-2.7 1.9-4.3 0-1.2-.3-2.3-1-3.3l-.5-.7c-1.1-1.6-2.9-2.6-4.9-2.6H15.3v-6.5h18.5c4.1 0 8 2 10.3 5.5l.5.7c1.4 2 2.1 4.4 2.1 6.9 0 3.5-1.5 6.8-4 9.1L36 45c-2.3 2.1-5.2 3.2-8.3 3.2h-3.4V54c0 .1 0 2.4-.1 4.6 0 1.9-1.3 3.6-3.1 4.3-.6.3-1.1.3-1.6.3zM38.9 86.5c-1.6 0-3.2-.8-4.2-2.1l-9.1-12.2c-1.5-2-1.4-4.6.2-6.5l6.5-7.7c1.6-1.8 4.2-2.4 6.3-1.3l8.9 4.5c1.8.9 2.9 2.7 2.9 4.7v4c0 .9-.2 1.7-.6 2.5l-6.3 11.5c-.9 1.6-2.4 2.6-4.2 2.7-.1-.1-.2-.1-.4-.1zm1-5.9zm-8.5-11.5l7.4 9.9 5.2-9.5v-2.9l-7.3-3.7-5.3 6.2z"
                    className="st0"
                ></path>
                <g>
                    <path
                    fill="currentColor"
                        d="M49.9 99.6C22.6 99.6.4 77.4.4 50.1S22.6.6 49.9.6s49.5 22.2 49.5 49.5-22.2 49.5-49.5 49.5zm0-92.5c-23.7 0-43 19.3-43 43s19.3 43 43 43 43-19.3 43-43-19.2-43-43-43z"
                        className="st0"
                    ></path>
                </g>
            </svg>
        </div>
    )
}

export default Earth
